<template>
  <main class="login">
    <section class="alinha-v">
      <div class="margem">
        <p class="logo">Thalamus</p>
        <h2 class="titulo-fluxo">{{ titulo }}</h2>
        <p class="texto-fluxo">{{ subtitulo }}</p>
        <fieldset>
          <div class="linha">
            <label class="icone-conta pos-input"></label>
            <input
              v-model="email"
              type="email"
              autocomplete="email"
              placeholder="E-mail cadastrado"
              @keyup.enter="enviarCodigo"
            />
          </div>
        </fieldset>
        <div class="submit">
          <button type="button" class="button" :disabled="loading" @click="enviarCodigo">
            <span class="icone-avancar direita"></span>
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>&nbsp;
            <span v-if="!loading">{{ textoBotao }}</span>
            <span v-else>Enviando...</span>
          </button>
        </div>
        <p class="voltar-login">
          <RouterLink :to="{ name: 'login' }">Voltar ao login</RouterLink>
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import apiR from "@/services/apiLogin.js";

const toaster = createToaster({
  position: "top-right",
  duration: 4000,
});

export default {
  name: "EsqueceuSenhaComponent",
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  computed: {
    motivo() {
      const q = this.$route.query?.motivo;
      return q === "primeiro-acesso" ? "primeiro-acesso" : "esqueci";
    },
    titulo() {
      return this.motivo === "primeiro-acesso" ? "Primeiro acesso" : "Recuperar senha";
    },
    subtitulo() {
      return this.motivo === "primeiro-acesso"
        ? "Informe o e-mail que a empresa cadastrou para você. Enviaremos um código para criar sua senha."
        : "Informe seu e-mail cadastrado. Enviaremos um código para redefinir sua senha.";
    },
    textoBotao() {
      return this.motivo === "primeiro-acesso" ? "Enviar código de acesso" : "Enviar código de recuperação";
    },
  },
  methods: {
    async enviarCodigo() {
      if (!this.email?.trim()) {
        toaster.show("Por favor, preencha o e-mail", { type: "error" });
        return;
      }

      this.loading = true;
      try {
        await apiR.post("enviar-codigo", { email: this.email.trim() });
        sessionStorage.setItem(
          "thalamus_senha_fluxo",
          JSON.stringify({
            motivo: this.motivo,
            email: this.email.trim(),
          })
        );
        toaster.show("Código enviado! Verifique sua caixa de e-mail (e o spam).", {
          type: "success",
        });
        this.$router.push({
          name: "ValidarToken",
          query: { motivo: this.motivo },
        });
      } catch (err) {
        console.error(err);
        const status = err.response?.status;
        const msg =
          status === 404
            ? "E-mail não cadastrado. Confira o endereço ou fale com o administrador."
            : err.response?.data?.message ||
              "Não foi possível enviar o código. Tente novamente em instantes.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.titulo-fluxo {
  margin: 0 0 0.35rem;
  font-size: 1.25rem;
  font-weight: 600;
}

.texto-fluxo {
  margin: 0 0 1.25rem;
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--cor-fonte-fraca, #666);
}

.voltar-login {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.9rem;
}

.voltar-login a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
